// アプリシェル（外枠）：サイドバー＋トップバー＋HUD＋ビュー領域。
import { NAV } from './nav.js'
import { hudHtml, setHud } from './hud.js'
import { getSelectedMonth } from './data/selectedMonth.js'

// ビルド日時（Vite の define で焼き込む・vite.config.js）。社内シェルのサイドバーにだけ出す。
// 目的: 開いているタブが最新デプロイかを一目で判別する（SW が古いバンドルを配る事故の検知）。
// 整形は Asia/Tokyo 固定なので、CI（UTC）ビルドでも日本時間で出る。
// define が効かない経路（素の node で読み込む等）でも壊れないよう typeof で受ける。
const BUILD_TIME = typeof __BUILD_TIME__ === 'string' ? __BUILD_TIME__ : ''
const BUILD_TIME_FULL = typeof __BUILD_TIME_FULL__ === 'string' ? __BUILD_TIME_FULL__ : ''

export function renderShell(root, { user, demo, onSignOut, onSignIn }) {
  const email = user?.email || (demo ? 'demo@acejapan.co' : '')
  const initial = (email[0] || 'A').toUpperCase()

  const navHtml = NAV.map((g) => `
    <div class="nav-group">
      <div class="nav-group__label">${g.group}</div>
      ${g.items.map((i) => `
        <a class="nav-item" data-id="${i.id}" href="#/${i.id}">
          <span class="nav-item__icon">${i.icon}</span>
          <span class="nav-item__label">${i.label}</span>
          ${i.badge ? `<span class="nav-item__badge">${i.badge}</span>` : ''}
        </a>`).join('')}
    </div>`).join('')

  root.innerHTML = `
    <div class="layout">
      <aside class="sidebar">
        <div class="brand">
          <div class="brand__mark">V</div>
          <div class="brand__text">
            <div class="brand__name">VEIL-Neb</div>
            <div class="brand__sub" title="${BUILD_TIME_FULL}">${BUILD_TIME ? `ビルド ${BUILD_TIME}` : ''}</div>
          </div>
        </div>
        <nav class="nav">${navHtml}</nav>
        <div class="sidebar__foot">統合TMS</div>
      </aside>
      <div class="main">
        <header class="topbar">
          <div class="topbar__title" id="view-title">ダッシュボード</div>
          <div class="topbar__right">
            <button class="btn" id="theme-toggle" title="画面の白/黒を切り替え" aria-label="画面の白/黒を切り替え"><svg width="14" height="14" viewBox="0 0 14 14" aria-hidden="true"><circle cx="7" cy="7" r="5.4" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M7 1.6 A5.4 5.4 0 0 1 7 12.4 Z" fill="currentColor"/></svg></button>
            ${demo ? '<span class="pill pill--warn">デモ表示 · Supabase未設定</span>' : ''}
            ${user
              ? `<span class="user"><span class="user__avatar">${initial}</span><span class="user__email">${email}</span></span>
                 <button class="btn" id="signout">サインアウト</button>`
              : `<span class="pill pill--warn">公開ビュー · 閲覧のみ</span>
                 <button class="btn" id="signin">サインイン</button>`}
          </div>
        </header>
        ${hudHtml()}
        <main class="view" id="view"></main>
      </div>
    </div>`

  // HUD の月だけはシェルが持つ（選択月は画面をまたいで保持される）。
  // 稼働・実車率は各ビューが setHud() で渡すまで**項目ごと出さない**。ダミーを置かない。
  setHud({ month: getSelectedMonth() })

  const tt = root.querySelector('#theme-toggle')
  if (tt) tt.addEventListener('click', () => {
    const el = document.documentElement
    const next = el.dataset.theme === 'light' ? 'dark' : 'light'
    el.dataset.theme = next
    try { localStorage.setItem('veil-theme', next) } catch {}
  })
  const soBtn = root.querySelector('#signout'); if (soBtn) soBtn.addEventListener('click', onSignOut)
  const siBtn = root.querySelector('#signin'); if (siBtn) siBtn.addEventListener('click', onSignIn)
  root.removeAttribute('aria-busy')
  return root.querySelector('#view')
}

export function highlightActive(id, title) {
  // 選択月は画面をまたいで保持される（UIUX仕様書 §6）。
  // HUD はシェルが1度描くだけなので、遷移のたびに月を取り直す。
  setHud({ month: getSelectedMonth() })
  document.querySelectorAll('.nav-item').forEach((el) => {
    el.classList.toggle('is-active', el.dataset.id === id)
  })
  const t = document.getElementById('view-title')
  if (t && title) t.textContent = title
}
